/* eslint-disable max-lines */
/* eslint-disable prefer-object-spread */
import { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Buffer } from 'buffer';
import { isMobile } from 'react-device-detect';
import { Box, Grid, IconButton, LinearProgress, Link, Snackbar, Typography } from '@mui/material';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { DocChecklistStyles as classes } from './DocChecklistStyles';
import Vector from '../../../images/Vector.svg';
import SuccessCheck from '../../../images/Document_Tick.png';
import { typeCorporationDbaPsc, typeDba, typeLlc, typeTrust } from './DocLabelTypes';
import {
  saveDocChecklist,
  uploadDocChecklist,
  uploadDocumentByPreSignedURL,
  uploadDocXLDocCheckilst,
  generateFileMD5,
} from '../../../services/uploadService';
import { productNameURLMapping } from '../../../services/productNameURLMapping';
import {
  CLICK_TO_UPLOAD,
  DOC_CHECKLIST_MESSAGE,
  DOC_CHECKLIST_SNACKBAR_MSG,
  DOC_CHECKLIST_HEADING_MESSAGE,
  COLOR1,
} from '../../../constants';
import Layout from '../../Layout';
import SnackbarCloseIcon from '../../../images/close_icon.svg';
import snackbarInfo from '../../../images/snackbar_info.svg';
import { businessMapping } from '../../../services/businessMapping';
import { productTypeMapping } from '../../../services/productTypeMapping';
import ComercialImage3 from '../../../images/Comercial_Image_3.png';
import SaveAppContactInfo from '../../SaveApp/SaveAppContactInfo';
import SaveContinueModal from '../../Modal/SaveContinueModal';

const DocChecklist = (props) => {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const {
    setCurrentPage,
    businessContactInformation,
    productName,
    location,
    progress,
    setProgress,
    docLabels,
    setDocLabels,
    uploadDocId,
    setUploadDocId,
    uploadStatus,
    setUploadStatus,
    uploadedFiles,
    setUploadedFiles,
    isDocChecklistDirty,
    setIsDocChecklistDirty,
    cancelDeed,
    cancelCorpRes,
    cancelCertIncorp,
    cancelArtIncorp,
    cancelListOff,
    cancelRegCer,
    cancelDbaRes,
    cancelLlcRes,
    cancelCertOrg,
    cancelOpAgree,
    cancelTrustReg,
    cancelIncumbency,
    checklistErr,
    setChecklistErr,
    productType,
    setIsModalSaveLater,
    isModalSaveLater,
    isModalSave,
    savedChecklistDocs,
  } = leadGenerationContext;
  const { history } = props;
  const wrapperRef = useRef(null);

  useEffect(() => {
    setCurrentPage('document-checklist');
  }, []);

  useEffect(() => {
    switch (businessContactInformation.businessType) {
      case 'DBA':
        setDocLabels(typeDba);
        break;
      case 'Corporation':
        setDocLabels(typeCorporationDbaPsc);
        break;
      case 'Corporation DBA':
        setDocLabels(typeCorporationDbaPsc);
        break;
      case 'LLC':
        setDocLabels(typeLlc);
        break;
      case 'Partnership':
        setDocLabels(typeCorporationDbaPsc);
        break;
      case 'Trust':
        setDocLabels(typeTrust);
        break;
      default:
        break;
    }
  }, []);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarstate, setSnackbarstate] = useState(true);

  const handleBack = () => {
    history?.push(
      `/${location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/commercial-form/${productNameURLMapping(
        productName
      )}/business-comp`
    );
  };
  const isChecklistValid = () => {
    let isStatusValid = true;
    for (const status in uploadStatus) {
      if (uploadStatus[status] === 'failed') {
        isStatusValid = false;
      }
    }
    return isStatusValid;
  };

  const setFocusForErrorFields = () => {
    for (const entityType in uploadStatus) {
      if (uploadStatus[entityType] === 'failed') {
        const element = document.getElementById(entityType);
        element.removeAttribute('tabindex');
        if (element) {
          element.setAttribute('tabindex', '0');
          element.focus();
          // break;
        }
      }
    }
  };
  const checkAllDocsUploaded = () => {
    let flag = false;
    switch (businessContactInformation.businessType) {
      case 'DBA':
        if (!uploadDocId.dbaResolution || !uploadDocId.regCertificate) {
          flag = true;
        }
        break;
      case 'Corporation':
      case 'Corporation DBA':
      case 'Partnership':
        if (
          !uploadDocId.corpResolution ||
          !uploadDocId.certIncorp ||
          !uploadDocId.articleIncorp ||
          !uploadDocId.listOfOfficers ||
          !uploadDocId.regCertificate
        ) {
          flag = true;
        }
        break;
      case 'LLC':
        if (
          !uploadDocId.LlcResolution ||
          !uploadDocId.certOfOrg ||
          !uploadDocId.opAgreement ||
          !uploadDocId.listOfOfficers ||
          !uploadDocId.regCertificate
        ) {
          flag = true;
        }
        break;
      case 'Trust':
        if (
          !uploadDocId.deedOfTrust ||
          !uploadDocId.certOfTrustReg ||
          !uploadDocId.certOfIncumbency ||
          !uploadDocId.regCertificate
        ) {
          flag = true;
        }
        break;
      default:
        break;
    }
    return flag;
  };
  const nextPageRouting = () => {
    if (
      businessMapping(productName) &&
      (productTypeMapping(productType) === 'Checking Account' ||
        productTypeMapping(productType) === 'Savings Account')
    ) {
      history?.push(
        `/${location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/commercial-form/${productNameURLMapping(
          productName
        )}/product-info`
      );
    } else {
      history?.push(
        `/${location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/commercial-form/${productNameURLMapping(
          productName
        )}/consent-info`
      );
    }
  };
  const handleContinue = async () => {
    const flagCheck = checkAllDocsUploaded();
    if (isDocChecklistDirty) {
      const valid = isChecklistValid();
      if (valid) {
        setIsLoading(true);
        const resp = await saveDocChecklist(uploadDocId, leadGenerationContext, flagCheck);
        if (resp && resp.status === 201) {
          setIsDocChecklistDirty(false);
          setIsLoading(false);
          nextPageRouting();
        } else {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
        setFocusForErrorFields();
      }
    } else {
      setIsLoading(false);
      nextPageRouting();
    }
  };
  const onDrop = (e, fileType) => {
    e.preventDefault();
    const fileNameOnDrop = e.target.name;
    setUploadStatus((prevState) => Object.assign({}, prevState, { [fileNameOnDrop]: '' }));
    const file = e.dataTransfer.files[0];
    setUploadedFiles({ ...uploadedFiles, [fileNameOnDrop]: file });
    if (file !== undefined && file !== null) {
      uploadFile(file, e, fileType);
    }
  };
  const onFileDrop = (e, fileType) => {
    e.preventDefault();
    setUploadStatus((prevState) => Object.assign({}, prevState, { [e.target.name]: '' }));
    const file = e.target.files[0];
    setUploadedFiles({ ...uploadedFiles, [e.target.name]: file });
    if (file !== undefined && file !== null) {
      uploadFile(file, e, fileType);
    }
  };
  const handleWrapperRef = () => {
    if (wrapperRef?.current?.value) {
      wrapperRef.current.value = '';
    }
  };
  const uploadFile = async (file, e, fileType) => {
    setIsFileUploading(true);
    const fileName = file.name;
    const fileParts = fileName.split('.');
    const fileExtension = fileParts[fileParts.length - 1].toLowerCase();
    const fileSize = file.size;
    const typeName = e.target.name;
    if (fileSize > 10485760) {
      handleWrapperRef();
      setIsFileUploading(false);
      setUploadStatus((prevState) => Object.assign({}, prevState, { [typeName]: 'failed' }));
      setChecklistErr((prevState) =>
        Object.assign({}, prevState, {
          [typeName]: 'The file exceeds the maximum upload size (10 Mb).',
        })
      );
      return;
    }
    const extensions = ['pdf', 'jpg', 'jpeg', 'png'];
    let isValidExtension = false;
    if (extensions.includes(fileExtension.toLowerCase())) isValidExtension = true;
    if (!isValidExtension) {
      handleWrapperRef();
      setIsFileUploading(false);
      setUploadStatus((prevState) => Object.assign({}, prevState, { [typeName]: 'failed' }));
      setChecklistErr((prevState) =>
        Object.assign({}, prevState, {
          [typeName]: 'Only files with the following formats are allowed: PNG, JPG, PDF.',
        })
      );
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    if (fileSize > 3145728) {
      const fileMD5 = await generateFileMD5(file);
      if (fileMD5) {
        await documentResponse(
          fileMD5,
          fileExtension,
          fileName,
          fileType,
          fileSize,
          file,
          typeName
        );
      } else {
        setIsFileUploading(false);
        setUploadStatus((prevState) => Object.assign({}, prevState, { [typeName]: 'failed' }));
        setChecklistErr((prevState) =>
          Object.assign({}, prevState, {
            [typeName]: CLICK_TO_UPLOAD,
          })
        );
      }
    } else {
      const response = await uploadDocChecklist(
        fileExtension,
        fileName,
        fileType,
        formData,
        leadGenerationContext.accessToken,
        typeName,
        setProgress,
        leadGenerationContext
      );

      if (response?.data) {
        setUploadDocId((prevState) =>
          Object.assign({}, prevState, { [typeName]: response.data.documentId })
        );
        setIsFileUploading(false);
        setUploadStatus((prevState) => Object.assign({}, prevState, { [typeName]: 'success' }));
        setIsDocChecklistDirty(true);
        leadGenerationContext.setIsCommercialProductUIDirty(true);

        setChecklistErr((prevState) =>
          Object.assign({}, prevState, {
            [typeName]: '',
          })
        );
      } else {
        setIsFileUploading(false);
        setUploadStatus((prevState) => Object.assign({}, prevState, { [typeName]: 'failed' }));
        setChecklistErr((prevState) =>
          Object.assign({}, prevState, {
            [typeName]: 'Click to upload again.',
          })
        );
      }
    }
  };

  const documentResponse = async (
    fileMD5,
    fileExtension,
    fileName,
    fileType,
    fileSize,
    file,
    typeName
  ) => {
    const fileMd5Base64 = Buffer.from(fileMD5, 'hex').toString('base64');
    const response = await uploadDocXLDocCheckilst(
      fileExtension,
      fileName,
      fileType,
      fileSize,
      fileMd5Base64,
      leadGenerationContext.accessToken,
      typeName,
      setProgress,
      leadGenerationContext
    );
    if (response?.data) {
      const documentId = response.data.documentId ? response.data.documentId : null;
      const preSignedUrl = response.data.preSignedUrl ? response.data.preSignedUrl : null;
      if (preSignedUrl && documentId) {
        const resp = await uploadDocumentByPreSignedURL(
          preSignedUrl,
          file,
          fileMd5Base64,
          leadGenerationContext.setStatementUploadProgress,
          leadGenerationContext.setStatementLinearProgress
        );
        preSignedUrlResponse(resp, documentId, typeName);
      } else {
        setIsFileUploading(false);
        setUploadStatus((prevState) => Object.assign({}, prevState, { [typeName]: 'failed' }));
        setChecklistErr((prevState) =>
          Object.assign({}, prevState, {
            [typeName]: 'Click to upload again.',
          })
        );
      }
    } else {
      setIsFileUploading(false);
      setUploadStatus((prevState) => Object.assign({}, prevState, { [typeName]: 'failed' }));
      setChecklistErr((prevState) =>
        Object.assign({}, prevState, {
          [typeName]: 'Click to upload again.',
        })
      );
    }
  };
  const preSignedUrlResponse = (resp, documentId, _typeName) => {
    if (resp && resp.status === 200) {
      setUploadDocId((prevState) => Object.assign({}, prevState, { [_typeName]: documentId }));
      setUploadStatus((prevState) => Object.assign({}, prevState, { [_typeName]: 'success' }));
      setIsFileUploading(false);
      setIsDocChecklistDirty(true);
      leadGenerationContext.setIsCommercialProductUIDirty(true);

      setChecklistErr((prevState) =>
        Object.assign({}, prevState, {
          [_typeName]: '',
        })
      );
    } else {
      setIsFileUploading(false);
      setUploadStatus((prevState) => Object.assign({}, prevState, { [_typeName]: 'failed' }));
      setChecklistErr((prevState) =>
        Object.assign({}, prevState, {
          [_typeName]: 'Click to upload again.',
        })
      );
    }
  };

  useEffect(() => {
    const types = [
      'corpResolution',
      'certIncorp',
      'articleIncorp',
      'listOfOfficers',
      'regCertificate',
      'dbaResolution',
      'LlcResolution',
      'certOfOrg',
      'opAgreement',
      'deedOfTrust',
      'certOfTrustReg',
      'certOfIncumbency',
    ];
    for (const type of types) {
      if (!uploadedFiles[type]) {
        setUploadDocId((prevState) => Object.assign({}, prevState, { [type]: '' }));
        setUploadStatus((prevState) => Object.assign({}, prevState, { [type]: '' }));
      }
    }
  }, [
    uploadDocId.corpResolution,
    uploadDocId.certIncorp,
    uploadDocId.articleIncorp,
    uploadDocId.listOfOfficers,
    uploadDocId.regCertificate,
    uploadDocId.dbaResolution,
    uploadDocId.LlcResolution,
    uploadDocId.certOfOrg,
    uploadDocId.opAgreement,
    uploadDocId.deedOfTrust,
    uploadDocId.certOfTrustReg,
    uploadDocId.certOfIncumbency,
    uploadStatus.corpResolution,
    uploadStatus.certIncorp,
    uploadStatus.articleIncorp,
    uploadStatus.listOfOfficers,
    uploadStatus.regCertificate,
    uploadStatus.dbaResolution,
    uploadStatus.LlcResolution,
    uploadStatus.certOfOrg,
    uploadStatus.opAgreement,
    uploadStatus.deedOfTrust,
    uploadStatus.certOfTrustReg,
    uploadStatus.certOfIncumbency,
  ]);
  const onKeyEnterCancel = (e) => {
    if (e.key === 'Enter') {
      handleCancel(e);
    }
  };
  const handleCancel = (e) => {
    if (e.target.name === 'deedOfTrust') {
      cancelDeed?.source?.cancel();
    }
    if (e.target.name === 'corpResolution') {
      cancelCorpRes?.source?.cancel();
    }
    if (e.target.name === 'certIncorp') {
      cancelCertIncorp?.source?.cancel();
    }
    if (e.target.name === 'articleIncorp') {
      cancelArtIncorp?.source?.cancel();
    }
    if (e.target.name === 'listOfOfficers') {
      cancelListOff?.source?.cancel();
    }
    if (e.target.name === 'regCertificate') {
      cancelRegCer?.source?.cancel();
    }
    if (e.target.name === 'dbaResolution') {
      cancelDbaRes?.source?.cancel();
    }
    if (e.target.name === 'LlcResolution') {
      cancelLlcRes?.source?.cancel();
    }
    if (e.target.name === 'certOfOrg') {
      cancelCertOrg?.source?.cancel();
    }
    if (e.target.name === 'opAgreement') {
      cancelOpAgree?.source?.cancel();
    }
    if (e.target.name === 'certOfTrustReg') {
      cancelTrustReg?.source?.cancel();
    }
    if (e.target.name === 'certOfIncumbency') {
      cancelIncumbency?.source?.cancel();
    }
    setIsDocChecklistDirty(true);
    leadGenerationContext.setIsCommercialProductUIDirty(true);

    setUploadedFiles({ ...uploadedFiles, [e.target.name]: '' });
    setUploadDocId((prevState) => Object.assign({}, prevState, { [e.target.name]: '' }));
    setUploadStatus((prevState) => Object.assign({}, prevState, { [e.target.name]: '' }));
    setProgress((prevState) => Object.assign({}, prevState, { [e.target.name]: 0 }));
  };
  // const getFilePreview = (fileItem) => URL.createObjectURL(uploadedFiles[fileItem.name]);
  const getFilePreview = (fileItem) => {
    let docType = '';
    for (const item in savedChecklistDocs) {
      if (savedChecklistDocs[item].type && savedChecklistDocs[item].preSignedUrl) {
        for (const label in docLabels) {
          if (
            docLabels[label].name === fileItem.name &&
            docLabels[label].label === savedChecklistDocs[item].type
          ) {
            docType = savedChecklistDocs[item].preSignedUrl;
            break;
          }
        }
      }
    }
    if (uploadedFiles[fileItem.name]?.type) {
      return URL.createObjectURL(uploadedFiles[fileItem.name]);
    }
    return docType;
  };
  const commonTernary = (condition, result1, result2) => {
    if (condition) {
      return result1;
    }
    return result2;
  };

  const handleClose = (_event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarstate(false);
  };
  const handleSaveApplication = (e) => {
    e.preventDefault();
    setIsModalSaveLater(true);
  };
  const mainComponent = () => (
    <>
      <Layout
        handleSaveApplication={handleSaveApplication}
        ariaDescribedby="docChecklistHeading"
        headingId="docChecklistHeading"
        ariaDescribedbyId="DocChecklistDesc"
        classes={classes}
        descriptionKey={DOC_CHECKLIST_MESSAGE}
        descriptionValue={DOC_CHECKLIST_MESSAGE}
        stepValue={2}
        handleBack={handleBack}
        handleContinue={handleContinue}
        disableCondition={isFileUploading || isLoading}
        backBtnTestid="back_button_testid"
        continueBtnTestid="continue_testId"
        screenLoading={isLoading}
        layoutImage={ComercialImage3}
      >
        <Box component="div" sx={classes.contentDiv}>
          <Grid id="closeId" container size={{ xs: 12 }} sx={classes.snackbarMargin}>
            <Snackbar
              id="snackbarId"
              open={snackbarstate}
              sx={classes.snackbarRoot}
              onClose={handleClose}
              slotProps={{
                content: {
                  sx: classes.snackbarStyleViaContentProps,
                },
              }}
              action={
                <IconButton
                  id="closeIconId"
                  sx={classes.snackBarBtn}
                  size="small"
                  color={COLOR1}
                  data-testid="snackbar_close_testid"
                  onClick={handleClose}
                >
                  <img
                    id="closeImgId"
                    src={SnackbarCloseIcon}
                    alt="Close"
                    height="24px"
                    width="24px"
                  />
                </IconButton>
              }
              message={
                <Box component="div" sx={classes.message}>
                  <span style={{ marginRight: '10px' }}>
                    <IconButton
                      sx={classes.snackBarBtn}
                      style={{ marginTop: 0 }}
                      size="small"
                      color={COLOR1}
                    >
                      <img src={snackbarInfo} alt="Icon" height="26px" width="26px" />
                    </IconButton>
                  </span>
                  <span>
                    {t(DOC_CHECKLIST_SNACKBAR_MSG, {
                      defaultValue: DOC_CHECKLIST_SNACKBAR_MSG,
                      nsSeparator: '|',
                    })}
                  </span>
                </Box>
              }
            />
          </Grid>

          <Box
            component="div"
            sx={
              snackbarstate
                ? classes.checklist_grid_margin
                : classes.checklist_grid_margin_no_snackbar
            }
          >
            <Grid container item>
              <Grid size={{ xs: 12 }}>
                <Typography
                  sx={classes.contact_heading_new}
                  // style={{ marginTop: snackbarstate ? '0' : '25px' }}
                  id="aboutYourBusiness"
                  variant="h2"
                  aria-label={t(DOC_CHECKLIST_HEADING_MESSAGE, {
                    defaultValue: DOC_CHECKLIST_HEADING_MESSAGE,
                    nsSeparator: '|',
                  })}
                >
                  {t(DOC_CHECKLIST_HEADING_MESSAGE, {
                    defaultValue: DOC_CHECKLIST_HEADING_MESSAGE,
                    nsSeparator: '|',
                  })}
                </Typography>
              </Grid>
            </Grid>
            {/* upload container */}
            <Grid container sx={classes.grid_container}>
              {docLabels.map((item) => (
                <Grid
                  size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
                  key={item.id}
                  sx={classes.gridItem}
                  role="section"
                >
                  <Box component="div" sx={classes.gridInnerDiv}>
                    <Box component="div" sx={classes.labelCheckContainer}>
                      <Typography sx={classes.businessType}>
                        {t(item.label, { defaultValue: item.label })}
                      </Typography>
                      {uploadStatus[item.name] === 'success' && (
                        <img
                          src={SuccessCheck}
                          alt="success icon"
                          name={item.name}
                          height="16px"
                          width="16px"
                        />
                      )}
                    </Box>
                    {/* main draggable container */}

                    {!uploadedFiles[item.name]?.name || uploadStatus[item.name] === 'failed' ? (
                      <>
                        <Box
                          component="div"
                          aria-roledescription={`Drag file here or Choose File ${item.label}`}
                          sx={[
                            classes.uploadContainer,
                            classes.box,
                            classes.box_a,
                            uploadStatus[item.name] === 'failed' && classes.error,
                          ]}
                          className="drop-file-input"
                          id={item.name}
                          tabIndex="0"
                        >
                          <Box component="span" sx={classes.dragDropText}>
                            <Box
                              component="input"
                              type="file"
                              tabIndex="-1"
                              name={item.name}
                              aria-label={` ${t(item.label)}`}
                              accept=".pdf,.jpg,.jpeg,.png"
                              sx={classes.fileInput}
                              data-testid={`file_change_${item.label}`}
                              onChange={(e) => onFileDrop(e, item.label)}
                              ref={wrapperRef}
                              onDrop={(e) => onDrop(e, item.label)}
                            />
                            {!isMobile &&
                              t('Drag and drop or ', { defaultValue: 'Drag and drop or ' })}
                            <Box component="span" sx={classes.chooseFile}>
                              {t('Choose file', { defaultValue: 'Choose file' })}
                            </Box>
                          </Box>
                        </Box>
                        {uploadStatus[item.name] === 'failed' && (
                          <span
                            role="alert"
                            style={{
                              color: 'red',
                              margin: '2px',
                              display: 'block',
                              fontSize: '14px',
                            }}
                            data-testid="document-upload-error"
                          >
                            {t(checklistErr[item.name], {
                              defaultValue: checklistErr[item.name],
                              nsSeparator: '|',
                            })}
                          </span>
                        )}
                      </>
                    ) : (
                      <div>
                        <Box component="div" sx={classes.displayUploaded}>
                          {commonTernary(
                            uploadStatus[item.name] === '',
                            <Typography style={{ wordBreak: 'break-all', paddingRight: '5px' }}>
                              {uploadedFiles[item.name]?.name}
                            </Typography>,
                            <Link
                              style={{ wordBreak: 'break-all', paddingRight: '5px' }}
                              sx={classes.uploadedFileName}
                              href={getFilePreview(item)}
                              target="_blank"
                            >
                              {uploadedFiles[item.name]?.name}
                            </Link>
                          )}
                          <Box component="span" sx={classes.cancelIcon}>
                            <IconButton
                              disableFocusRipple
                              className="smallIconFocus"
                              id="closeIconId"
                              data-testid={`cancel_testid_${item.name}`}
                              name={item.name}
                              onClick={handleCancel}
                              onKeyDown={onKeyEnterCancel}
                              size="small"
                              color="inherit"
                            >
                              <img
                                src={Vector}
                                alt={t('cancel icon', { defaultValue: 'cancel icon' })}
                                name={item.name}
                                height="12px"
                                width="12px"
                              />
                            </IconButton>
                          </Box>
                        </Box>

                        {commonTernary(
                          uploadStatus[item.name] === '',
                          <LinearProgress
                            variant="determinate"
                            value={progress[item.name]}
                            classes={{
                              barColorPrimary: classes.progressColor,
                            }}
                            sx={classes.linearBar}
                          />,
                          ''
                        )}
                      </div>
                    )}
                    <div
                      style={{ marginTop: '8px', display: 'flex', justifyContent: 'space-between' }}
                    >
                      <Box component="div" sx={classes.file_size} style={{ paddingRight: '10px' }}>
                        {' '}
                        {t('Supported file types: PNG, JPG, PDF.', {
                          defaultValue: 'Supported file types: PNG, JPG, PDF.',
                          nsSeparator: '|',
                        })}
                      </Box>
                      <Box
                        component="div"
                        sx={classes.file_size}
                        style={{ paddingLeft: '10px', textAlign: 'right' }}
                      >
                        {' '}
                        {t('Maximum: 10MB', {
                          defaultValue: 'Maximum: 10MB',
                          nsSeparator: '|',
                        })}
                      </Box>
                    </div>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </Layout>
      {isModalSave && <SaveContinueModal />}

      {isModalSaveLater && (
        <SaveAppContactInfo openModal={isModalSaveLater} currentPage="document-checklist" />
      )}
    </>
  );
  return (
    // <div className="custom-container" role="main" aria-labelledby="docChecklistHeading">
    //   <ProductHeading
    //     id="docChecklistHeading"
    //     ariaDescribedbyId="DocChecklistDesc"
    //     productName={t(`Document Checklist`, { defaultValue: `Document Checklist` })}
    //     stepDescription={t('Upload the required documents to open your account.', {
    //       defaultValue: 'Upload the required documents to open your account.',
    //     })}
    //   />
    //   <Grid container>
    //     <Grid container size={{ xs: 12,md:8 }} spacing={1}>
    //       <Grid className={classes.business_info_stepper}>
    //         <StepperWizard steps={2} />
    //       </Grid>
    //     </Grid>
    //   </Grid>
    //   <div className={classes.upload_grid_margin}>
    //     <div>
    //       <Typography className={classes.text_upload_later_head}>
    //         {t('Uploading your documents is easy', {
    //           defaultValue: 'Uploading your documents is easy',
    //         })}
    //       </Typography>
    //       <div className={classes.text_Container}>
    //         <img
    //           src={UploadLaterImg}
    //           alt="Upload Later icon"
    //           style={{ marginRight: '15px', alignSelf: 'baseline' }}
    //           name="Doc upload"
    //           height="30px"
    //           width="36px"
    //         />
    //         <Typography className={classes.text_upload_later}>
    //           {t(
    //             'Proceed by uploading whichever documents you have. We will send a link to your email to upload any missing documents.',
    //             {
    //               defaultValue:
    //                 'Proceed by uploading whichever documents you have. We will send a link to your email to upload any missing documents.',
    //             }
    //           )}
    //         </Typography>
    //       </div>
    //     </div>
    //   </div>
    //   <div className={classes.checklist_grid_margin}>
    //     {/* upload container */}
    //     <Grid container style={{ marginTop: '30px' }} spacing={4}>
    //       {docLabels.map((item) => (
    //         <Grid
    //           item
    //           xs={12}
    //           sm={6}
    //           md={6}
    //           key={item.id}
    //           className={classes.gridItem}
    //           role="section"
    //         >
    //           <div className={classes.gridInnerDiv}>
    //             <div className={classes.labelCheckContainer}>
    //               <Typography className={classes.businessType}>
    //                 {t(item.label, { defaultValue: item.label })}
    //               </Typography>
    //               {uploadStatus[item.name] === 'success' && (
    //                 <img
    //                   src={SuccessCheck}
    //                   alt="success icon"
    //                   name={item.name}
    //                   height="16px"
    //                   width="16px"
    //                 />
    //               )}
    //             </div>
    //             {/* main draggable container */}

    //             {!uploadedFiles[item.name]?.name || uploadStatus[item.name] === 'failed' ? (
    //               <>
    //                 <div
    //                   aria-roledescription={`Drag file here or Choose File ${item.label}`}
    //                   tabIndex="0"
    //                   className={`${classes.uploadContainer} ${classes.box} ${classes.box_a} ${
    //                     uploadStatus[item.name] === 'failed' && classes.error
    //                   } drop-file-input`}
    //                   id={item.name}
    //                   style={{ padding: '10px' }}
    //                 >
    //                   <span className={classes.dragDropText}>
    //                     <input
    //                       type="file"
    //                       tabIndex="-1"
    //                       name={item.name}
    //                       aria-label={` ${t(item.label)}`}
    //                       accept=".pdf,.jpg,.jpeg,.png"
    //                       className={classes.fileInput}
    //                       onChange={(e) => onFileDrop(e, item.label)}
    //                       ref={wrapperRef}
    //                       onDrop={(e) => onDrop(e, item.label)}
    //                     />
    //                     {!isMobile && t('Drag file here or', { defaultValue: 'Drag file here or' })}{' '}
    //                     <span className={classes.chooseFile}>
    //                       {t('Choose file', { defaultValue: 'Choose file' })}
    //                     </span>
    //                   </span>
    //                 </div>
    //                 {uploadStatus[item.name] === 'failed' && (
    //                   <span
    //                     role="alert"
    //                     style={{
    //                       color: 'red',
    //                       margin: '2px',
    //                       display: 'block',
    //                       fontSize: '14px',
    //                     }}
    //                     data-testid="document-upload-error"
    //                   >
    //                     {t(checklistErr[item.name], {
    //                       defaultValue: checklistErr[item.name],
    //                       nsSeparator: '|',
    //                     })}
    //                   </span>
    //                 )}
    //               </>
    //             ) : (
    //               <div>
    //                 <div className={classes.displayUploaded}>
    //                   {commonTernary(
    //                     uploadStatus[item.name] === '',
    //                     <Typography style={{ wordBreak: 'break-all', paddingRight: '5px' }}>
    //                       {uploadedFiles[item.name]?.name}
    //                     </Typography>,
    //                     <Link
    //                       style={{ wordBreak: 'break-all', paddingRight: '5px' }}
    //                       className={classes.uploadedFileName}
    //                       href={getFilePreview(item)}
    //                       target="_blank"
    //                     >
    //                       {uploadedFiles[item.name]?.name}
    //                     </Link>
    //                   )}
    //                   <span className={classes.cancelIcon}>
    //                     <IconButton
    //                       id="closeIconId"
    //                       name={item.name}
    //                       onClick={handleCancel}
    //                       onKeyDown={onKeyEnterCancel}
    //                       size="small"
    //                       color="inherit"
    //                     >
    //                       <img
    //                         src={Vector}
    //                         alt={t('cancel icon', { defaultValue: 'cancel icon' })}
    //                         name={item.name}
    //                         height="12px"
    //                         width="12px"
    //                       />
    //                     </IconButton>
    //                   </span>
    //                 </div>

    //                 {uploadStatus[item.name] === '' ? (
    //                   <LinearProgress
    //                     variant="determinate"
    //                     value={progress[item.name]}
    //                     classes={{
    //                       barColorPrimary: classes.progressColor,
    //                       root: classes.linearBar,
    //                     }}
    //                   />
    //                 ) : (
    //                   ''
    //                 )}
    //               </div>
    //             )}
    //             <div style={{ marginTop: '8px', display: 'flex', justifyContent: 'space-between' }}>
    //               <div className={classes.file_size}>
    //                 {' '}
    //                 {t('Supported file types: PNG, JPG, PDF.', {
    //                   defaultValue: 'Supported file types: PNG, JPG, PDF.',
    //                   nsSeparator: '|',
    //                 })}
    //               </div>
    //               <div className={classes.file_size}>
    //                 {' '}
    //                 {t('Max. 10MB', {
    //                   defaultValue: 'Max. 10MB',
    //                   nsSeparator: '|',
    //                 })}
    //               </div>
    //             </div>
    //           </div>
    //         </Grid>
    //       ))}
    //     </Grid>
    //   </div>
    //   <Grid container className={classes.button_grid_Later} direction="row" alignItems="center">
    //     <Grid  size={{ xs: 12 }} className={classes.personal_button_container}>
    //       <Button
    //         className={classes.back_button}
    //         onClick={handleBack}
    //         data-testid="back_button_testid"
    //       >
    //         {t('Back', { defaultValue: 'Back' })}
    //       </Button>
    //       <Button
    //         disabled={isFileUploading}
    //         onClick={handleContinue}
    //         classes={{ disabled: classes.disabled_button }}
    //         className={classes.continue_button}
    //         data-testid="continue_testId"
    //       >
    //         {t('Continue', { defaultValue: 'Continue' })}
    //       </Button>
    //     </Grid>
    //   </Grid>
    //   {isLoading && (
    //     <div
    //       style={{
    //         position: 'fixed',
    //         top: 0,
    //         bottom: 0,
    //         alignItems: 'center',
    //         display: 'flex',
    //         justifyContent: 'center',
    //         width: '100%',
    //       }}
    //     >
    //       <Loader />
    //     </div>
    //   )}
    // </div>
    <>{mainComponent()}</>
  );
};

export default withRouter(DocChecklist);
DocChecklist.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};
